const PopoverStyle = () => {
  return {
    styleOverrides: {
      root: {
        "& .MuiPaper-root": {
          backgroundColor: "var(--Schemes-Surface)",
          border: "1px solid var(--Schemes-Outline-Variant)",
          padding: "4px 8px 8px 8px",
          borderRadius: "8px",
          boxShadow: "0px 4px 15px rgba(0,0,0,0.2)",
          minWidth: 360,
          minHeight: 100,
        }
      }
    }
  }
}
export default PopoverStyle